module.exports = __webpack_public_path__ + "assets/RhombusInTriangleDetailed.f77fe3cc485b50803ff87e744bc8e545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/RhombusInTriangleDetailed.png
// module id = 556
// module chunks = 0